export default __webpack_public_path__ + "static/media/view-all.594ae169.png";